// Modules
import { companyLineInview } from "../alpineModules/companyLineInview";
import { homeMv } from "../alpineModules/homeMv";
import { companyProfileItemsReveal } from "../modules/companyProfileItemsReveal";
import { companyProfileTitleScrollFill } from "../modules/companyProfileTitleScrollFill";
import { footerImagesReveal } from "../modules/footerImagesReveal";
import { menu } from "../modules/menu";

export const initScripts = () => {
  const cleanupFunctions: (() => void)[] = [];

  const companyProfileTitleFillCleanup = companyProfileTitleScrollFill();
  if (companyProfileTitleFillCleanup) {
    cleanupFunctions.push(companyProfileTitleFillCleanup);
  }

  const footerImagesRevealCleanup = footerImagesReveal();
  if (footerImagesRevealCleanup) {
    cleanupFunctions.push(footerImagesRevealCleanup);
  }

  const companyProfileItemsRevealCleanup = companyProfileItemsReveal();
  if (companyProfileItemsRevealCleanup) {
    cleanupFunctions.push(companyProfileItemsRevealCleanup);
  }

  return cleanupFunctions;
}

export const initAlpineScripts = () => {
  document.addEventListener("alpine:init", () => {
    menu();
    companyLineInview();
    homeMv();
  });
}
